import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

// Renders the audit body markdown with Tailwind Typography classes plus
// a few overrides so it sits well on the dark + light themes. Anchors
// open in the same tab; we trust audit content (it's our own AI's output).
export function AuditMarkdown({ body, className }: { body: string; className?: string }) {
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none dark:prose-invert",
        // Tighter spacing than default `prose` and a brand-aware link colour.
        "prose-p:my-3 prose-headings:mt-6 prose-headings:mb-3",
        "prose-h1:text-xl prose-h2:text-lg prose-h3:text-base",
        "prose-strong:text-foreground prose-code:text-primary prose-code:bg-muted",
        "prose-code:rounded prose-code:px-1 prose-code:py-0.5 prose-code:font-mono prose-code:text-[0.85em]",
        "prose-code:before:content-[''] prose-code:after:content-['']",
        "prose-a:text-primary prose-a:no-underline hover:prose-a:underline",
        "prose-ul:my-3 prose-li:my-1",
        "prose-hr:my-6 prose-hr:border-border",
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
    </div>
  );
}
